export const styles = {
  header: {
    "& .MuiPaper-root": {
      backgroundColor: "events.grayShade2",
    },
  },
};
